// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, {FC, useState, useEffect, useLayoutEffect, useCallback, useRef} from "react";
// antd:
import { Space, Layout, Button, Form, Input, Skeleton } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

// import { useNavigate, useLocation } from "react-router-dom";
// Redux-hooks:
import { useAppSelector, useAppDispatch } from "../libs/redux-hooks.ts";
// Reducer:
import { getDict, getUser, reloadConfigAndApps } from "../libs/reducer.ts";

import fnc from "../libs/fnc.ts";
import AppIcons from "../components/react/AppIcons.tsx";
import DivE from "../components/react/DivE.tsx";

// const { rz } = window;

let ssoReq = false, timerID, timerValue = 30;

const LoginPage:FC = () => {
  const dispatch = useAppDispatch();
  const dct = useAppSelector(getDict);
  const user = useAppSelector(getUser);

  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const passwordInput = useRef(null);

  // ReDraw Desktop-container if User changes Screen-size:
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dummyValue, setRedrawTimeStamp] = useState(() => ((new Date().getTime())));
  useLayoutEffect(() => { // On document was changed size
    function updateWindowSize() { setRedrawTimeStamp((new Date().getTime())) }
    window.addEventListener("resize", updateWindowSize);
    return () => window.removeEventListener("resize", updateWindowSize);
  }, []);

  // ======== Component did mount ========
  useLayoutEffect(() => {
    if (!ssoReq && !user.login) {
      ssoReq = true;
      // Try to SSO authorization
      fnc.ssoLogin().then(async (ans):Promise<void> => {
        if (ans && ans.result && ans.user && ans.user.name) { dispatch(reloadConfigAndApps(true)) }
        else { setLoading(false) }
      });
    }
    else {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // Timer on Mini-Button
  const [timerState, setTimerState] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dummyValue2, updateInterfaceByTimer] = useState(30);
  if (timerState && !timerID) {
    timerValue = 30; updateInterfaceByTimer(timerValue);
    timerID = setInterval(() => {
      if (timerValue <= 0) { setTimerState(false); clearInterval(timerID); timerID = undefined; } else { timerValue--; updateInterfaceByTimer(timerValue) }
    }, 1000);
  }
  else if (!timerState && timerID) {
    setTimerState(false); clearInterval(timerID); timerID = undefined;
  }

  const doLogin = useCallback((e:{user:string, pass:string}) => {
    fnc.userLogin({...e, codeAccepted: timerState}).then((ans) => {
      setTimerState(false);
      if (ans && ans.result && ans.user && ans.user.login) { dispatch(reloadConfigAndApps(true)) }
      else {
        form.resetFields();
        // @ts-ignore
        passwordInput?.current?.focus();
      }
    });
  }, [dispatch, form, timerState]);

  // Login Form
  const layout = { labelCol: {span: 10}, wrapperCol: {span: 14} };
  const tailLayout = { wrapperCol: {span: 24}, className: "uk-flex uk-flex-right" };

  const sendMeCode = useCallback<React.MouseEventHandler<HTMLElement>>(() => {
    const values = form.getFieldsValue();
    if (values.user && !values.pass && !timerState) {
      setTimerState(true);
      fnc.sendAuthCode(values.user).then((ans1) => {
        if (!ans1.result || ans1.err) { setTimerState(false) }
        // @ts-ignore
        passwordInput?.current?.focus();
      });
    }
  }, [form, timerState]);

  return (
    <Layout className="layout">
      <video autoPlay muted loop id="bg-video-3d-lines">
        <source src="/img/bg/earth_amcham.mp4" type="video/mp4" />
      </video>
      <Layout.Content className="content-fixed">
        <div className="uk-flex uk-flex-center uk-flex-middle" style={{ height: (window.innerHeight), width: "100%", padding: "10px 10px" }} >
          {loading ? (
            <div className="uk-grid uk-child-width-1-1 uk-text-right" style={{width: "324px"}}>
              <div style={{marginBottom: "24px"}}><Skeleton.Input active={true} size="large" /></div>
              <div style={{marginBottom: "24px"}}><Skeleton.Input active={true} size="large" /></div>
              <div style={{marginBottom: "24px"}}><Skeleton.Input active={true} size="large" /></div>
            </div>
          ) : (
            <Form {...layout} form={form} name="user-login-form" className="rz-width-3-4@xs rz-width-1-3@sx" onFinish={doLogin}>
              <Form.Item name="user" label={dct.p.fieldlogin} rules={[{required: true}]}>
                <Space.Compact style={{ width: "100%" }}>
                  <Input key="sAMAccountName" tabIndex={1} />
                  <Button key="sendcode" id="sendcode" type="primary" uk-tooltip={dct.p.sendMeCode} onClick={sendMeCode} disabled={timerState} >
                    {timerState
                      ? (<DivE key="timerValue" className="uk-text-center">{timerValue}</DivE>)
                      : (<AppIcons key="sendcode1" icopath="fa/FaTelegramPlane" attrs={{size: "1.5em"}} />)
                    }
                  </Button>
                </Space.Compact>
              </Form.Item>
              <Form.Item name="pass" label={dct.p.fieldpass} rules={[{required: true}]}>
                <Input.Password key="pwd" tabIndex={2} ref={passwordInput} iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
              </Form.Item>
              <Form.Item {...tailLayout}>
                <Button key="submit" id="submit" htmlType="submit" type="primary" onClick={sendMeCode}>
                  {dct.p.send}
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      </Layout.Content>
    </Layout>
  );
}

export default LoginPage;
